import camelcase from 'camelcase';

const reg = /^@weapp\//;
const error = new Error("App does not exist");

export default function appInfo(app: string) {
  if (!reg.test(app)) {
    throw error;
  }
  const name: string = app.replace(reg, () => '');
  if (!name) {
    throw error;
  }
  const libraryName: string = camelcase('weapp-' + name);
  const publicUrlVar: string = `publicUrl${libraryName}`;
  const publicUrl: string = window[publicUrlVar] || window.publicUrlstatic || window.publicUrl || '';
  const publicDomainVar: string = `publicDomain${libraryName}`;
  const publicDomain: string = window[publicDomainVar] || window.publicDomainstatic || '';
  const buildFolder: string = `${publicDomain}${publicUrl}/build/${name}`;
  return {
    name,
    libraryName,
    publicUrlVar,
    publicUrl,
    publicDomainVar,
    publicDomain,
    buildFolder,
  }
}